import { MiddlewareFunc } from '../../types';
import { DockConfiguration } from '../index';
import { cyrb53 } from './utils';

const getFingerprint = async (url: string): Promise<string> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch fingerprint from ${url}`);
    }
    const responseText = await response.text();
    return cyrb53(responseText);
  } catch (error) {
    console.error(`Error fetching fingerprint`, error);
    return '';
  }
};

const appendFingerprintToUrl = (url: string, fingerprint: string) => {
  const urlObj = new URL(url, window.location.origin);
  if (fingerprint) {
    urlObj.searchParams.set('fingerprint', fingerprint);
  }
  return urlObj.href;
};

export const fingerprintMiddleware: MiddlewareFunc<DockConfiguration> = async (
  dockConfig,
) => {
  const config = dockConfig as DockConfiguration;
  if (config.core?.bundleFingerprintUrl && config.microfrontends?.length) {
    const fingerprint = await getFingerprint(config.core.bundleFingerprintUrl);
    config.microfrontends = config.microfrontends?.map((mfe) => {
      return {
        ...mfe,
        url: appendFingerprintToUrl(mfe.url, fingerprint),
      };
    });
  }
  return config;
};
